export default __webpack_public_path__ + "static/media/landscape.e564b94b.JPG";